<script>
  import { onMount } from 'svelte'
  import { fade } from 'svelte/transition'
  import MediaQuery from './MediaQuery.svelte'
  import Checkbox from './checkbox.svelte'

  gsap.registerPlugin(ScrollTrigger)

  export let content
  let tester

  let OTFeatures = [
    { name: 'Bold' },
    {
      name: 'All Caps',
      glyphs: ['(', ')', '[', ']', '{', '}', '-', '—', '–', '@'],
      tag: 'case',
    },
    { name: 'Short Caps', tag: 'ss01' },
    { name: 'Closed CJc', glyphs: ['C', 'J', 'c'], tag: 'ss02' },
    { name: 'Narrow Jr', glyphs: ['J', 'r'], tag: 'ss03' },
    { name: 'Italian A', glyphs: ['A'], tag: 'ss04' },
    { name: 'Single-story a', glyphs: ['a'], tag: 'ss05' },
    { name: 'Long Q', glyphs: ['Q'], tag: 'ss06' },
  ]

  let activeFeatures = []
  let isBold = false
  let isUppercase = false
  let featureString

  function updateFeatureList(tag) {
    if (activeFeatures.includes(tag)) {
      let tagIdx = activeFeatures.indexOf(tag)
      activeFeatures.splice(tagIdx, 1)
    } else {
      activeFeatures.push(tag)
    }
  }

  function listGlyphsToHighlight() {
    let glyphsToHighlight = []
    activeFeatures.forEach((e) => {
      let feature = OTFeatures.find((x) => x.tag === e.slice(1, 5))
      if (typeof feature.glyphs !== 'undefined') {
        glyphsToHighlight = glyphsToHighlight.concat(feature.glyphs)
      }
    })
    return glyphsToHighlight
  }

  function setHighlighting(text) {
    let glyphsToHighlight = listGlyphsToHighlight()
    let newContent = ''
    for (let i = 0; i < text.length; i++) {
      if (glyphsToHighlight.includes(text[i])) {
        newContent +=
          '<span style="color: var(--green);">' + text[i] + '</span>'
      } else {
        newContent += text[i]
      }
    }
    return newContent
  }

  function updateHighlighting() {
    let sel = window.getSelection()
    let cursorPos = sel.anchorOffset
    //content = setHighlighting(tester.textContent)

    let range = document.createRange()
  }

  function handleToggle(event) {
    let option = event.detail.name
    let feature = OTFeatures.find((x) => x.name === option)
    if (feature.name === 'Bold') {
      isBold = !isBold
    } else if (feature.name === 'All Caps') {
      isUppercase = !isUppercase
      updateFeatureList("'case'")
    } else {
      updateFeatureList("'" + feature.tag + "'")
    }
    featureString = activeFeatures.join(',')
  }

  let testerWrapper
  let stickyMenu
  let activeMenu = true
  onMount(() => {
    setTimeout(() => {
      gsap.from('.tester-item', {
        opacity: 0,
        y: -20,
        stagger: 0.2,
        scrollTrigger: {
          trigger: '.tester-item',
          start: 'top bottom',
          toggleActions: 'play none none reverse',
        },
      })
    }, 200)

    ScrollTrigger.matchMedia({
      '(max-width: 834px)': () => {
        activeMenu = false
        stickyMenu = ScrollTrigger.create({
          trigger: testerWrapper,
          start: 'top 70%',
          end: 'bottom 80%',
          onEnter: () => {
            activeMenu = true
          },
          onLeave: () => {
            activeMenu = false
          },
          onEnterBack: () => {
            activeMenu = true
          },
          onLeaveBack: () => {
            activeMenu = false
          },
        })
      },
    })

    return () => {
      if (stickyMenu) {
        stickyMenu.kill()
      }
    }
  })
</script>

<div class="cols4-wrapper" bind:this={testerWrapper}>
  <p
    contentEditable="true"
    class:isBold
    class:isUppercase
    on:input={updateHighlighting}
    bind:this={tester}
    style="
     font-feature-settings:{featureString};
    ">
    {@html content}
  </p>

  {#if activeMenu}
    <MediaQuery query="(max-width: 834px)" let:matches>
      {#if matches}
        <div class="tester-options mobile" transition:fade>
          <ul>
            {#each OTFeatures as feature}
              <li class="tester-item">
                <Checkbox name={feature.name} on:toggle={handleToggle} />
              </li>
            {/each}
          </ul>
        </div>
      {/if}
    </MediaQuery>
  {/if}

  <MediaQuery query="(min-width: 835px)" let:matches>
    {#if matches}
      <div class="tester-options" transition:fade>
        <ul>
          {#each OTFeatures as feature}
            <li class="tester-item">
              <Checkbox name={feature.name} on:toggle={handleToggle} />
            </li>
          {/each}
        </ul>
      </div>
    {/if}
  </MediaQuery>
</div>

<style lang="scss">
  @import '../responsive.scss';

  p {
    grid-column: 1 / span 2;
    font-family: 'Arteria-Regular';
    font-size: 10rem;
    line-height: 1em;
    color: var(--light);
    caret-color: var(--dark);
    &.isBold {
      font-family: 'Arteria-Bold';
    }
    &.isUppercase {
      text-transform: uppercase;
    }
    &:focus {
      outline: none;
    }
    &::selection {
      background-color: var(--red);
      color: var(--light-accent);
    }

    @include for-tablet {
      font-size: 6rem;
    }

    @include for-tablet-p {
      grid-column: 1 / span 3;
    }

    @include for-phone {
      font-size: 4rem;
      margin-bottom: 100px;
    }
  }
  .tester-options {
    margin-top: 35px;
    li {
      margin-bottom: 5px;
    }

    @include for-tablet {
      margin-top: 18px;
    }
  }

  .mobile {
    grid-column: 1 / span 3;
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: var(--red);
    padding: 20px 0;
    padding-left: 1em;
    z-index: 3;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        margin-right: 10px;
      }
    }
  }
</style>
